// Copyright ©️ 2026 eVolve MEP, LLC

import React, { type ReactNode, useMemo } from 'react';

import { MantineProvider } from '@mantine/core';
import { v4 as uuid } from 'uuid';

export const WithColorScheme = ({
  children,
  colorScheme,
  ...props
}: { children: ReactNode; colorScheme: 'light' | 'dark' } & React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>) => {
  const id = useMemo(() => `a${uuid().replaceAll('-', '')}`, []);
  const selector = `#${id}`;
  return (
    <div {...props} id={id}>
      <MantineProvider
        // oxlint-disable-next-line typescript/no-non-null-assertion
        getRootElement={() => document.querySelector<HTMLElement>(selector)!}
        cssVariablesSelector={selector}
        forceColorScheme={colorScheme}
      >
        {children}
      </MantineProvider>
    </div>
  );
};
